module.exports = __webpack_public_path__ + "static/media/dgl2.png.90cea993.jpg";